export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgProfile = require("../assets/profileImage.png")
export const imgProfileCover = require("../assets/profileCoverImage.png")
export const imgCameraIcon = require("../assets/image_camera.svg")
export const iconCheckBox = require('../assets/checkbox.svg')
export const iconCheckBoxChecked = require('../assets/checkbox_checked.svg')